import { FC } from 'react'
import styles from 'components/features/future/FutureInputDecoration/FutureInputDecoration.styl'
import { resolveErrorById } from 'constants/errors'

type FutureInputDecorationErrorProps = {
  type?: string
}
export const FutureInputDecorationError: FC<FutureInputDecorationErrorProps> = (props) => {
  const { type } = props

  return (
    <div className={ styles.error }>
      { type && resolveErrorById(type as any) }
    </div>
  )

}
